import { apiClient } from './client';
import { AgentCommission, CommissionSummary } from '../types/commission.types';

export const commissionsApi = {
  // Obtener resumen de comisiones con período
  getSummary: async (period: string = 'month'): Promise<CommissionSummary> => {
    const { data } = await apiClient.get('/agents/me/earnings', {
      params: { period },
    });
    // Normalize response: handle different field names the backend may return
    return {
      totalEarned: data.totalEarned ?? data.total ?? data.totalAmount ?? 0,
      pending: data.pending ?? data.pendingAmount ?? 0,
      pendingCount: data.pendingCount ?? data.pendingTransactions ?? 0,
      paid: data.paid ?? data.paidAmount ?? data.thisMonth ?? 0,
      paidCount: data.paidCount ?? data.paidTransactions ?? 0,
      withheld: data.withheld ?? data.withheldAmount ?? 0,
      withheldCount: data.withheldCount ?? data.withheldTransactions ?? 0,
      total: data.total ?? data.totalEarned ?? data.totalAmount ?? 0,
      totalCount: data.totalCount ?? data.totalTransactions ?? 0,
      thisMonth: data.thisMonth ?? data.thisMonthAmount ?? 0,
      lastMonth: data.lastMonth ?? data.lastMonthAmount ?? 0,
      averagePerTransaction: data.averagePerTransaction ?? data.average ?? 0,
    };
  },

  // Obtener lista de comisiones
  getList: async (params: {
    status?: string;
    page?: number;
    limit?: number;
    startDate?: string;
    endDate?: string;
  }): Promise<{
    data: AgentCommission[];
    total: number;
    page: number;
    totalPages: number;
  }> => {
    const { data } = await apiClient.get('/agents/me/commissions', { params });
    // Normalize: handle array response or wrapped response
    const items: AgentCommission[] = Array.isArray(data)
      ? data
      : Array.isArray(data?.data)
      ? data.data
      : Array.isArray(data?.commissions)
      ? data.commissions
      : Array.isArray(data?.items)
      ? data.items
      : [];
    return {
      data: items,
      total: data?.total ?? data?.meta?.total ?? items.length,
      page: data?.page ?? data?.meta?.page ?? params.page ?? 1,
      totalPages: data?.totalPages ?? data?.meta?.totalPages ?? data?.pages ?? 1,
    };
  },

  // Exportar comisiones a CSV
  exportToCSV: async (params: { status?: string; period?: string }): Promise<Blob> => {
    const { data } = await apiClient.get('/agents/me/commissions/export', {
      params,
      responseType: 'blob',
    });
    return data;
  },

  // Obtener comisiones del agente (método legacy)
  getAll: async (filters?: {
    page?: number;
    limit?: number;
    status?: 'PENDING' | 'PAID' | 'WITHHELD' | 'CANCELLED';
    startDate?: string;
    endDate?: string;
  }): Promise<{ commissions: AgentCommission[]; total: number; page: number; pages: number }> => {
    const response = await commissionsApi.getList({
      ...filters,
      limit: filters?.limit || 20,
    });
    return {
      commissions: response.data,
      total: response.total,
      page: response.page,
      pages: response.totalPages,
    };
  },

  // Solicitar pago de comisiones
  requestPayout: async (amount: number): Promise<any> => {
    const { data } = await apiClient.post('/commissions/request-payout', { amount });
    return data;
  },
};
